import React, { CSSProperties } from "react";
import { DD_MM_YYYY } from "src/helpers";
import { Note } from "src/types";
import { TextWithLineBreaks } from "./ui";

interface NotesDisplayProps {
  note: Note;
  displayMeta?: boolean;
  style?: CSSProperties;
}

const NoteDisplay: React.FC<NotesDisplayProps> = ({ note, displayMeta, style }) => {
  const formattedDate = DD_MM_YYYY.formatDate(new Date(note.date));

  return (
    <div className="flex flex-col max-w-[800px] min-w-[200px] max-h-[550px] cursor-not-allowed" style={style}>
      <div className="w-[90%] border border-secondary-200 bg-input rounded-lg p-4 mb-2.5 text-sm text-secondary-900 leading-normal">
        <TextWithLineBreaks text={note.body} />
      </div>
      {displayMeta && (
        <div className="text-xs text-muted-600 mb-2.5">
          Tag: {note.tag} | Date Updated: {formattedDate}
        </div>
      )}
    </div>
  );
};

export { NoteDisplay };
